import webAppConfig from "../commons/webApp.config";

//signalr
var connection = $.hubConnection();
connection.url =
    (webAppConfig.baseURL ? webAppConfig.baseURL : "") + "/signalr";
var qhub = connection.createHubProxy("fETIASHub");

var connectHub = async function () {
    var authData = JSON.parse(
        window.localStorage.getItem("ls.authorizationData")
    );

    if (authData) {
        connection.qs = {
            Authorization: authData.access_token,
            connectionData: "[{ name: 'fetiashub' }]"
        };
    }

    await connection.start();
    console.log("hub connected. " + moment().format("DD-MM-YYYY HH:mm:ss"));

    // connection.start().done(function() {
    //     console.log("hub connected. " + moment().format("DD-MM-YYYY HH:mm:ss"));
    //     qhub.invoke('joinWorkspace', workspaceId);
    // });
}

var getConnectionState = function() {
    let status = '';
    console.log(qhub.connection.state)

    switch(qhub.connection.state)
    {
        case $.signalR.connectionState.connecting:
            status = 'connecting';
            break;
            
        case $.signalR.connectionState.connected:
            status = 'connected';
            break;
            
        case $.signalR.connectionState.reconnecting:
            status = 'reconnecting';
            break;
            
        case $.signalR.connectionState.disconnected:
            status = 'disconnected';
            break;
    }

    return status;
}

var setupCommunication = async function (workspaceId) {
    if(getConnectionState() == 'disconnected') {
        await connectHub();
    }

    qhub.invoke('joinWorkspace', workspaceId);

    connection.reconnecting(function () {
        console.log(
            "hub reconnecting. " + moment().format("DD-MM-YYYY HH:mm:ss")
        );
    });

    connection.reconnected(function () {
        console.log(
            "hub reconnected. " + moment().format("DD-MM-YYYY HH:mm:ss")
        );
    });

    connection.disconnected(function () {
        console.log(
            "hub disconnected. " + moment().format("DD-MM-YYYY HH:mm:ss")
        );

        setTimeout(function () {
            connection.start().done(function () {
                console.log('hub connected. ' + moment().format('DD-MM-YYYY HH:mm:ss'));
                qhub.invoke('joinWorkspace', workspaceId);
            });
        }, 10000);
    });

    connection.error(function (err) {
        console.log(
            "HUB ERROR: " + err + ". " + moment().format("DD-MM-YYYY HH:mm:ss")
        );
    });
};

qhub.on("scriptDebug", function (data) {
    console.log(data);
});

qhub.on("refreshNotification", function (data) {
    window.eventBus.$emit("refreshNotification");
});

qhub.on('moduleChanged', function(data) {
    window.eventBus.$emit("moduleChanged", data);
})

export default {
    setupCommunication: setupCommunication,
}